import React, { useEffect, useState } from "react";
import { TopBar } from "@/components/TopBar";
import { EmptyState } from "@/components/EmptyState";
import { useI18n } from "@/i18n";
import { useRouter } from "@/router/Router";
import { useBackButton } from "@/lib/hooks";
import { deleteAddress, fetchAddresses, type SavedAddress } from "@/lib/api";
import { confirmAction } from "@/lib/telegram";

/** Saved delivery addresses ("Дом", "Офис", "Мама") — added at checkout, managed here. */
export function AddressesPage() {
  const { t } = useI18n();
  const { goBack } = useRouter();
  useBackButton(goBack);
  const [list, setList] = useState<SavedAddress[] | null>(null);
  const load = () => fetchAddresses().then(setList).catch(() => setList([]));
  useEffect(() => {
    load();
  }, []);
  return (
    <>
      <TopBar title={t("addresses.title")} onBack={goBack} />
      <main className="page page--no-nav">
        {list === null ? (
          <p>{t("common.loading")}</p>
        ) : list.length === 0 ? (
          <EmptyState art="generic" title={t("addresses.empty")} hint={t("addresses.emptyHint")} />
        ) : (
          list.map((a) => (
            <div key={a.id} className="card" style={{ padding: 14, marginBottom: 10 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <b style={{ fontFamily: "var(--font-display)", fontWeight: 400, fontSize: 17 }}>{a.label}</b>
                <button
                  className="btn btn--danger-text"
                  onClick={async () => {
                    if (await confirmAction(t("addresses.confirmDelete", { label: a.label }))) {
                      await deleteAddress(a.id).catch(() => {});
                      load();
                    }
                  }}
                >
                  {t("addresses.delete")}
                </button>
              </div>
              <div style={{ fontSize: 13.5, color: "var(--color-ink-soft)", lineHeight: 1.6, marginTop: 4 }}>
                {a.fullName} · {a.phone}
                <br />
                {a.address}
                {a.comment ? <><br />{a.comment}</> : null}
              </div>
            </div>
          ))
        )}
      </main>
    </>
  );
}
